import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { FormControlsUtilsModule } from '../form-controls-utils/form-controls-utils.module';
import { PhoneControlComponent } from './phone-control/phone-control.component';
import { PhoneCountrySelectComponent } from './phone-country-select/phone-country-select.component';
import { PhoneFormControlComponent } from './phone-form-control.component';



@NgModule({
  declarations: [
    PhoneFormControlComponent,
    PhoneCountrySelectComponent,
    PhoneControlComponent
  ],
  exports: [
    PhoneFormControlComponent
  ],
  imports: [
    CommonModule,

    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatAutocompleteModule,

    MatIconModule,

    FormControlsUtilsModule
  ]
})
export class PhoneFormControlModule { }
